export function PoliticaEnviosPage() {
  return (
    <section className="px-4 sm:px-6 md:px-14 py-10 md:py-16 max-w-2xl mx-auto flex flex-col gap-5">
      <h1 className="text-4xl font-display font-semibold text-wood">Política de Envíos y Pagos</h1>
      <div className="flex flex-col gap-3">
        <h2 className="text-lg font-semibold text-ink">Pagos</h2>
        <p className="text-[14px] leading-relaxed text-ink-muted">
          No procesamos pagos en línea. Al finalizar tu carrito, te enviamos un resumen por WhatsApp
          para coordinar el pago directamente: transferencia bancaria, Yape, Plin o efectivo contra
          entrega.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <h2 className="text-lg font-semibold text-ink">Envíos</h2>
        <p className="text-[14px] leading-relaxed text-ink-muted">
          Coordinamos el envío y el punto de entrega directamente contigo por WhatsApp una vez
          confirmado tu pedido. El costo y tiempo de envío dependen de tu ubicación.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <h2 className="text-lg font-semibold text-ink">Pedidos por volumen</h2>
        <p className="text-[14px] leading-relaxed text-ink-muted">
          Para pedidos grandes (parroquias, colegios, negocios), aprovecha los precios por paquete
          (docena, medio ciento, ciento) disponibles en cada producto.
        </p>
      </div>
    </section>
  );
}
